import { IconButton } from "@mui/material";
import DataTable from "app/components/DataTable";
import { ThreedotIcon } from "app/icons";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Manufacturer } from "../../types";
import { useStyles } from "./style";

type Props = {
  rows: Manufacturer[];
  loading?: boolean;
};

const ManufacturerTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "menu",
        label: "",
        width: 48,
        align: "center",
        format: () => (
          <IconButton size="small" className={styles.menuButton}>
            <ThreedotIcon />
          </IconButton>
        ),
      },
      {
        id: "priority",
        label: t("MANUFACTURERS.TABLE.PRIORITY"),
        align: "center",
        format: (row: Manufacturer) => (
          <span className={styles.priorityCell}>{row.priority}</span>
        ),
      },
      {
        id: "nameKey",
        label: t("MANUFACTURERS.TABLE.MANUFACTURER_NAME"),
        width: 180,
        minWidth: 180,
        maxWidth: 220,
        align: "right",
        format: (row: Manufacturer) => t(row.nameKey),
      },
      {
        id: "serial",
        label: "#",
        width: 48,
        align: "right",
        format: (_row: Manufacturer, index: number) => index + 1,
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("MANUFACTURERS.EMPTY")}
      />
    </div>
  );
};

export default ManufacturerTable;
